<!--
 * @Description: 项目支付通道
 * @Date: 2022-12-26 14:01:33
-->
<template>
  <el-form-item label="项目支付通道：" v-if="showPayChannel">
    <el-input style="width:300px" disabled :value="payTypeText"></el-input>
    <el-tag type="danger" v-if="isOffline">服务商线下支付</el-tag>
  </el-form-item>
</template>

<script>
import { mapState } from 'vuex';
import { payBankFormatter } from '@/common/fields/bank';
import { OFFLINE_PATTERN_TYPES } from '@/common/constants/project';

const TOOL_BUSINESS_TYPE = 9; // 工具业务结构
const MODEL_CONSULT = 2; // 协商模式
const MODEL_BIDDING = 1; // 招标
const AUDIT_PASS = 3; // 审核通过

export default {
  name: 'project-classify-pay-channel',
  computed: {
    ...mapState({
      homeProject: state => state.homeProject,
      showPayChannel() {
        // 工具不展示项目付款渠道
        return this.homeProject.businessType !== TOOL_BUSINESS_TYPE;
      }
    }),
    // 支付通道
    payTypeText() {
      // 协商模式,则按撮合项目时设置的通道显示,不可修改
      if (this.homeProject.projectCooperateMode === MODEL_CONSULT) {
        return payBankFormatter(this.homeProject);
      }
      // 招商模式则显示”项目审核通过后可见”,当项目审核通过后,将配置的通道显示出来
      if (this.homeProject.projectCooperateMode === MODEL_BIDDING) {
        if (this.homeProject.auditStatus === AUDIT_PASS) {
          return payBankFormatter(this.homeProject);
        } else {
          return '项目暂未提交审核，审核通过后可见。';
        }
      }
      return '';
    },
    // 是否为线下项目
    isOffline() {
      return OFFLINE_PATTERN_TYPES.includes(this.homeProject.patternType);
    }
  }
};
</script>
